module.exports = __webpack_public_path__ + "static/Заявление_о_закрытии_счета_архив-8ff74eb43d14145e66362b15d2937b02.pdf";